import Browser from './browser';
var VistaprintTenant = 'vistaprint';
var VistaTenant = 'vista';
var PromotiqueTenant = 'promotique';
var PayPalTenant = 'paypal';
var AllowedTenants = [VistaprintTenant, VistaTenant, PromotiqueTenant];
var MasksTenant = 'masks';
var Brandstore = 'brandstore';
var Novelty = 'novelty';
var MASK_PATHS = [
    'masken',
    'mondkapjes',
    'masks',
    'masker',
    'maskit',
    'masque',
    'mascherine',
    'munnbind',
    'mascaras',
    'mascarillas',
    'munskydd'
];
var PAYPAL_PATHS = [
    'touch-free-payments'
];
export var getCurrentTenantOrDefault = function (defaultTenant) {
    var pathname = Browser.getPathname();
    if (pathname && pathname !== '/') {
        var pathParts = pathname.split('/');
        for (var j = 0; j < pathParts.length; j += 1) {
            if (MASK_PATHS.indexOf(pathParts[j].toLowerCase()) !== -1) {
                return MasksTenant;
            }
            if (PAYPAL_PATHS.indexOf(pathParts[j].toLowerCase()) !== -1) {
                return PayPalTenant;
            }
        }
    }
    var hostnameParts = Browser.getHostname().split('.');
    var domainHostnameParts = hostnameParts.slice(-3);
    if (domainHostnameParts[0]
        && domainHostnameParts[0].toLocaleLowerCase() === Brandstore
        && domainHostnameParts[1] === VistaprintTenant) {
        return PromotiqueTenant;
    }
    if (domainHostnameParts[0]
        && domainHostnameParts[0].toLocaleLowerCase() === Novelty
        && domainHostnameParts[1] === VistaprintTenant) {
        return PromotiqueTenant;
    }
    for (var i = domainHostnameParts.length - 1; i >= 0; i -= 1) {
        if (AllowedTenants.indexOf(domainHostnameParts[i]) !== -1) {
            return domainHostnameParts[i];
        }
    }
    return defaultTenant;
};
export var getCurrentTenant = function () {
    return getCurrentTenantOrDefault(VistaprintTenant);
};
//# sourceMappingURL=data:application/json;base64,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